if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      
      if( this.querySelector('.product-media-modal__content') != null ){
		var _slider = this.querySelector('.product-media-modal__content');
        $(_slider).slick();
      }
      
      this.showActiveMedia();
    }

    showActiveMedia() {      
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element,index) => {          
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]:not(.slick-cloned)`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();      
      
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
      
      var $slides = $(this).find('.product-media-modal__content.slick-initialized')[0].slick.$slides;
      if( $slides.length > 0 ){
        setTimeout(function(){
          $($slides).each((index,element) => {            
            if($( element ).hasClass('active')){              
              $(this).find('.product-media-modal__content.slick-initialized').slick('slickGoTo',index);
            } });
        },300)
      }
    }
  });
}
